import type { CustomBlockEntity } from '@unifyapps/defs/blocks/Custom/types';
import { useState } from 'react';
import type BlocksRegistry from '../context/RegistryProvider/BlocksRegistry';

export function useInitialiseCustomBlocks(
  registry: BlocksRegistry,
  customBlocks?: CustomBlockEntity[],
) {
  /*
    We intentionally avoid useEffect here.
    Custom Block definitions must be registered synchronously and exactly once,
    before any consumers attempt to read from the registry.
    Using useEffect would delay registration until after paint,
    which could cause missed/duplicate registrations or subtle resolution bugs.
  */
  useState(() => {
    if (!customBlocks?.length) return;
    customBlocks.forEach((customBlock) => {
      registry.addCustomBlock(customBlock);
    });
  });
}
